import { getMetricsInfo } from 'owa-calendar-compose-store-manager';

export default function getFormOpenDuration(formId: string): number {
    const metricsInfo = getMetricsInfo(formId);
    return (
        (metricsInfo.timeInQuickCompose || 0) +
        (metricsInfo.timeInFullCompose || 0) +
        (metricsInfo.timeInSchedulingAssistant || 0)
    );
}
